import { BellOutlined } from '@ant-design/icons';
import { Badge, Spin, Tabs } from 'antd';
import classNames from 'classnames';
import useMergedState from 'rc-util/es/hooks/useMergedState';
import React, { useState } from 'react';
import HeaderDropdown from '../HeaderDropdown';
import styles from './index.less';
import type { NoticeIconTabProps } from './NoticeList';
import NoticeList from './NoticeList';

const { TabPane } = Tabs;

export type NoticeIconProps = {
  count?: number;
  bell?: React.ReactNode;
  className?: string;
  loading?: boolean;
  onClear?: (tabName: string, tabKey: string) => void;
  onItemClick?: (item: API.NoticeIconItem, tabProps: NoticeIconTabProps) => void;
  onRead?: (item: API.NoticeIconItem, tabProps: NoticeIconTabProps) => void;
  onViewMore?: (tabProps: NoticeIconTabProps, e: MouseEvent) => void;
  onTabChange?: (tabTile: string) => void;
  style?: React.CSSProperties;
  onPopupVisibleChange?: (visible: boolean) => void;
  popupVisible?: boolean;
  clearText?: string;
  viewMoreText?: string;
  clearClose?: boolean;
  emptyImage?: string;
  children?: React.ReactElement<NoticeIconTabProps>[];
  onBtnClick?:any;
};

const NoticeIcon: React.FC<NoticeIconProps> & {
  Tab: typeof NoticeList;
} = (props: any) => {
  const [activeTabKey, setActiveTabKey] = useState<any>(props.children[0]?.props?.tabKey || '');

  const handleTabChange = (key: any) => {
    setActiveTabKey(key);
    if (props.onTabChange) {
      props.onTabChange(key);
    }
  };

  const getNotificationBox = (): React.ReactNode => {
    const {
      children,
      loading,
      onClear,
      onTabChange,
      onItemClick,
      onRead,
      onViewMore,
      clearText,
      viewMoreText,
      onBtnClick
    } = props;
    if (!children) {
      return null;
    }

    const panes: React.ReactNode[] = [];

    React.Children.forEach(children, (child: React.ReactElement<NoticeIconTabProps>): void => {
      if (!child) {
        return;
      }

      const { list, title, count, tabKey, showClear, showViewMore } = child.props;
      const len = list && list.length ? list.length : 0;

      const msgCount = count || count === 0 ? count : len;

      const tabTitle: string = msgCount > 0 ? `${title} (${msgCount})` : title;

      panes.push(
        <TabPane
          tab={
            <div className={styles.tab_name_with_unread_count}>
              <div>Notification</div>
              <div
                className={
                  activeTabKey === tabKey ? styles.unread_count_active : styles.unread_count
                }
              >
                {msgCount}
              </div>
            </div>
          }
          key={tabKey}
        >
          <NoticeList
            clearText={clearText}
            viewMoreText={viewMoreText}
            list={list}
            tabKey={tabKey}
            onClear={(): void => onClear && onClear(title, tabKey)}
            onClick={(item): void => onItemClick && onItemClick(item, child.props)}
            onItemRead={(item): void => onRead && onRead(item, child.props)}
            onViewMore={(event): void => onViewMore && onViewMore(child.props, event)}
            showClear={showClear}
            showViewMore={showViewMore}
            title={title}
            count={msgCount}
          />
        </TabPane>,
      );
    });
    return (
      <>
        {/* <div className={styles.notification_heading}>Notifications</div> */}
        <Spin spinning={loading} delay={300}>
          <Tabs size={'small'} className={styles.tabs} onChange={handleTabChange}>
            {panes}
          </Tabs>
        </Spin>
      </>
    );
  };

  const { className, count, bell,onBtnClick } = props;

  const [visible, setVisible] = useMergedState<boolean>(false, {
    value: props.popupVisible,
    onChange: props.onPopupVisibleChange,
  });
  const noticeButtonClass = classNames(className, styles.noticeButton);
  const notificationBox = getNotificationBox();
  const NoticeBellIcon = bell || <BellOutlined className={styles.icon} />;
  const handleClick = () => {
    if (onBtnClick) {
      onBtnClick(); // Call the function when clicked
    }
  };
  const trigger = (
    <span className={classNames(noticeButtonClass, { opened: visible })} onClick={handleClick}>
      <Badge count={count} style={{ boxShadow: 'none' }} className={styles.badge} >
        {/* <Badge count={10} style={{ boxShadow: 'none' }} className={styles.badge}> */}
        {NoticeBellIcon}
      </Badge>
    </span>
  );
  if (!notificationBox) {
    return trigger;
  }

  return (
    <HeaderDropdown
      placement="bottomRight"
      overlay={notificationBox}
      overlayClassName={styles.popover}
      trigger={['click']}
      visible={visible}
      onVisibleChange={setVisible}
    >
      {trigger}
    </HeaderDropdown>
  );
};

NoticeIcon.defaultProps = {
  emptyImage: 'https://gw.alipayobjects.com/zos/rmsportal/wAhyIChODzsoKIOBHcBk.svg',
};

NoticeIcon.Tab = NoticeList;

export default NoticeIcon;
